const Circleofdreams = () => {
    return (
        <div class="projectpending-status">
            <img src="/project-images/CircleOfDreams2.jpg" alt="" />
            <h2>🚧 Codename: Circle of Dreams</h2>
            <p>This project is currently ongoing and will be launched soon. Stay tuned!</p>
        </div>
    )
}
export default Circleofdreams